import "./index.css";
import PrimaryButton from "../../../_utils/CommonButtons/PrimaryButton";
import { useEffect, useState } from "react";
import DeletePopup from "./DeletePopup";
import ChangeKeyPopup from "./ChangeKeyPopup";
import UniversalRefreshToast from "../../../_utils/UniversalRefreshToast";
import { toast } from "react-toastify";
import TEXT from "../../../../utils/globalText";
import CommonToast from "../../../_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const BYOKstatus = ({
  isBYOKEncProcessing,
  selectKey,
  currentFetchedKey,
  setCurrentDisplay,
  setCanEncrypt,
  setByokProcessPending,
  setBankingSelected,
  setSelectKey,
  setActiveStep,
  fetchCreadentials,
  isRotatingKeys,
  setisRotatingKeys,
  setRotatingKey,
  encryptedKey,
  setIsUpdateKey,
  setIsKeyDecrypted,
  setByokProcessFailed,
  setCredentialsFocus,
  setCredentials,
  updatedKeyDone,
  setUpdatedKeyDone,
  isChangeKeyFlowComplted,
  isEncryptDone,
}) => {
  const [deletePop, setDeletePop] = useState(false);
  const [changeKeyPop, setChangeKeyPop] = useState(false);
  // const [showToast, setShowToast] = useState(false);

  const handleUpdateKey = () => {
    setIsUpdateKey(true);
    setCurrentDisplay("BYOKstepperPage");
    setActiveStep(0);
  };

  useEffect(() => {
    if (isBYOKEncProcessing) {
      // toast.dismiss();
      UniversalRefreshToast("Data encryption is in process");
    } else {
      toast.dismiss();
      if (updatedKeyDone) {
        CommonToast({
          text: "Credentials has been updated",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setUpdatedKeyDone(false);
      } else if (isChangeKeyFlowComplted) {
        CommonToast({
          text: "Key has been changed successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else if (isEncryptDone) {
        CommonToast({
          text: "Data encrypted successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }
  }, [isBYOKEncProcessing, updatedKeyDone]);

  useEffect(() => {
    if (deletePop || changeKeyPop) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto"; // clean up on unmount
    };
  }, [deletePop, changeKeyPop]);

  const handleFunction = () => {
    if (!currentFetchedKey) {
      CommonToast({
        text: "Please update your credentials first",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return;
    }
    setChangeKeyPop(true);
  };

  const handleDeleteFunction = () => {
    if (!currentFetchedKey) {
      CommonToast({
        text: "Please update your credentials first",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return;
    }
    setDeletePop(true);
  };

  return (
    <div className="Qlg:w-max-content-width w-full mx-auto pt-padding-md Qlg:px-padding-base px-padding-md bg-primary-bg">
      <div style={{ zIndex: !deletePop && "var(--z-index-header)" }}>
        {deletePop && (
          <div
            className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal"
            style={{
              backgroundColor: "var(--PopUp-BackDrop)",
              opacity: "var(--dark-opacity)",
            }}
          ></div>
        )}
        <DeletePopup
          deletePop={deletePop}
          setDeletePop={() => setDeletePop(false)}
          selectKey={selectKey}
          currentFetchedKey={currentFetchedKey}
          setCurrentDisplay={setCurrentDisplay}
          setCanEncrypt={setCanEncrypt}
          setByokProcessPending={setByokProcessPending}
          setIsKeyDecrypted={setIsKeyDecrypted}
          setByokProcessFailed={setByokProcessFailed}
          setSelectKey={setSelectKey}
          setBankingSelected={setBankingSelected}
          setIsUpdateKey={setIsUpdateKey}
        />
      </div>
      <div style={{ zIndex: !changeKeyPop && "var(--z-index-header)" }}>
        {changeKeyPop && (
          <div
            className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal"
            style={{
              backgroundColor: "var(--PopUp-BackDrop)",
              opacity: "var(--dark-opacity)",
            }}
          ></div>
        )}
        <ChangeKeyPopup
          changeKeyPop={changeKeyPop}
          setChangeKeyPop={() => setChangeKeyPop(false)}
          selectKey={selectKey}
          currentFetchedKey={currentFetchedKey}
          setCurrentDisplay={setCurrentDisplay}
          setCanEncrypt={setCanEncrypt}
          setByokProcessPending={setByokProcessPending}
          setBankingSelected={setBankingSelected}
          setSelectKey={setSelectKey}
          setActiveStep={setActiveStep}
          fetchCreadentials={fetchCreadentials}
          isRotatingKeys={isRotatingKeys}
          setisRotatingKeys={setisRotatingKeys}
          setRotatingKey={setRotatingKey}
          encryptedKey={encryptedKey}
          setCredentialsFocus={setCredentialsFocus}
          setCredentials={setCredentials}
          // setShowToast={setShowToast}
        />
      </div>
      {isBYOKEncProcessing ? (
        <div className="byok-status-pending">
          <div className="byok-status-text">
            <h3>{TEXT?.ENCRYPTION_IN_PROCESS}</h3>
            <ul>
              {TEXT?.KEY_INTEGRATION_PROCESS.split(".")
                .filter(Boolean)
                .map((sentence, index) => (
                  <li key={index}>{sentence.trim()}.</li>
                ))}
            </ul>
          </div>
          <div className="byok-status-img">
            <img
              src={
                "https://q2pay.in/new_assets/graphics/byok/encryption_in_process.svg"
              }
              alt="BYOK encryption in progress"
            />
          </div>
        </div>
      ) : (
        <div className="flex Qlg:flex-row flex-col p-padding-md bg-primary-card rounded-border-radius-md gap-gap-md">
          <div
            className="flex flex-col gap-gap-md"
            style={{
              paddingBottom: "calc(var(--padding-sm) + var(--padding-xs))",
            }}
          >
            <div className="flex flex-col gap-gap-sm">
              <h3 className="text-text-primary text-font-md font-semibold">
                {TEXT?.BYOK_ENCRYPTION} -&nbsp;
                <span className="text-settled text-font-md font-semibold">
                  {TEXT?.ACTIVE}
                </span>
              </h3>

              <p className="text-text-secondary text-font-xs font-normal">
                {TEXT?.KEY_LINKED_SUCCESS}
              </p>
            </div>
            <div className="flex flex-col gap-gap-sm">
              <h4 className="text-text-secondary text-font-xs font-normal">
                {TEXT?.LINKED_AWS_KEY} :{" "}
                {!selectKey && !currentFetchedKey
                  ? "Your session has been expired, update your credential to view key"
                  : ""}
              </h4>
              {!selectKey && !currentFetchedKey ? (
                <div style={{ width: "fitContent" }}>
                  <PrimaryButton
                    btnText={TEXT?.UPDATE_CREDENTIAL}
                    btnType="button"
                    handleFunction={handleUpdateKey}
                    isDisabled={false}
                    enabledTextColor="var(--text-primary)"
                    disabledTextColor="var(--text-primary)"
                    enabledBgColor="var(--primary-nav-act)"
                    disabledBgColor="var(--text-disabled)"
                    isLoading={false}
                    hoverOption="white"
                  />
                </div>
              ) : (
                <div className="key-id-div p-padding-sm text-text-secondary text-font-sm font-semibold bg-primary-nav-act rounded-border-radius-sm">
                  <p>{selectKey || currentFetchedKey}</p>
                </div>
              )}
            </div>
          </div>
          <img
            src={"https://q2pay.in/new_assets/graphics/byok/active.svg"}
            alt="BYOK encryption activated"
            className="Qlg:h-graphic-byok-img-height h-graphic-byok-img-mobile-height"
          />
        </div>
      )}

      <div className="bg-negative-card mt-margin-md rounded-border-radius-md flex items-center gap-gap-md py-padding-md px-padding-lg">
        <img
          src={"https://q2pay.in/new_assets/common/dashboard/alert_white.svg"}
          alt="warningImg"
          className="w-icon-lg h-icon-lg"
        />
        <div className="flex flex-col gap-gap-sm">
          <h3 className="text-text-primary text-font-sm font-normal">
            {TEXT?.DO_NOT_DELETE_KEY}
          </h3>
          <p className="text-text-secondary text-font-xs font-normal">
            {TEXT?.DELETING_KEY_RISK}
          </p>
        </div>
      </div>

      <div className="flex Qlg:flex-row flex-col Qlg:gap-gap-xl gap-gap-md mt-margin-md">
        <div className="bg-primary-card flex-1 p-padding-md rounded-border-radius-md flex flex-col gap-gap-md">
          <div className="flex flex-col gap-gap-sm">
            <h2 className="text-text-primary text-font-sm font-semibold">
              Change Key (Rotate Key)
            </h2>
            <h3 className="text-text-secondary text-font-xs font-normal">
              {TEXT?.CHANGE_KEY_WARNING}
            </h3>
          </div>

          <PrimaryButton
            btnText={TEXT?.CHANGE_KEY}
            btnType="button"
            handleFunction={handleFunction}
            isDisabled={false}
            enabledTextColor="var(--text-primary)"
            disabledTextColor="var(--text-primary)"
            enabledBgColor="var(--primary-nav-act)"
            disabledBgColor="var(--text-disabled)"
            isLoading={false}
            hoverOption="white"
            fullWidthRequired={true}
          />
        </div>
        <div className="bg-primary-card flex-1 p-padding-md rounded-border-radius-md flex flex-col gap-gap-md">
          <div className="flex flex-col gap-gap-sm">
            <h2 className="text-text-primary text-font-sm font-semibold">
              {TEXT?.DELETE_SETUP}
            </h2>
            <h3 className="text-text-secondary text-font-xs font-normal">
              {TEXT?.DELETE_SETUP_WARNING}
            </h3>
          </div>

          <PrimaryButton
            btnText="Delete setup"
            btnType="button"
            handleFunction={handleDeleteFunction}
            isDisabled={false}
            enabledTextColor="var(--text-primary)"
            disabledTextColor="var(--text-primary)"
            enabledBgColor="var(--primary-nav-act)"
            disabledBgColor="var(--text-disabled)"
            isLoading={false}
            hoverOption="white"
            fullWidthRequired={true}
          />
        </div>
      </div>
    </div>
  );
};

export default BYOKstatus;
